import reducer from './reducer'

import * as companiesOperations from './operations'
import * as companiesSelectors from './selectors'

export { companiesOperations, companiesSelectors }

export default reducer
